export default __webpack_public_path__ + "static/media/goshen33.e7d0deb7.jpg";